import React from "react";
import { CloudCtxProvider } from "./controllers/cloud";
import { Route } from "react-router-dom";
import Home from "./views/Home";
import Login from "./views/Login";
import SignUp from "./views/SignUp";
import { Routes } from "react-router";
import { useAuthCtx } from "./controllers/auth";

const App = () => {
  const authCtx = useAuthCtx();
  const logged = authCtx.logged;

  return (
    logged !== "not" && (
      <CloudCtxProvider>
        <Routes>
          <Route path={"/"} element={<Home />} exact />
          <Route path={"/login"} element={<Login />} exact />
          <Route path={"/sign-up"} element={<SignUp />} exact />
          {/*<Route path={"/home"} element={<Dashboard />} exact />*/}
          <Route path={"*"} element={<Home />} />
        </Routes>
      </CloudCtxProvider>
    )
  );
};

export default App;
